import React, { useEffect, useState } from "react";


export {ToggleButton};

function ToggleButton({ data, defaultValue, setValue, isTooltip = false }) {
    const [selected, setSelected] = useState(defaultValue);
    
    const setSelectedValue = value => {
        setValue(value);
        setSelected(value);
    };

    useEffect(() => {
        setValue(defaultValue);
        setSelected(defaultValue)
    }, [defaultValue])

    return (
        <div className={`${isTooltip ? "bg-toggle-tooltip " : "bg-toggle "} flex-row flex justify-around`}>
            {!isTooltip &&
                data.map((element, index) => {
                    return (
                        <div
                            key={index}
                            className={selected === element.value ? "btn-toggle-selected" : "btn-toggle-disabled"}
                            onClick={() => setSelectedValue(element.value)}
                        >
                            {element.name}
                        </div>
                    );
                })
            }
            {isTooltip &&
                data.map((element, index) => {
                    return (
                        <div
                            key={index}
                            className={selected === element.value ? "btn-toggle-tooltip-selected" : "btn-toggle-tooltip-disabled"}
                        >
                            {element.name}
                        </div>
                    );
                })
            }
        </div>
    );
};
